import type { ListBoxItemProps as AriaListBoxItemProps } from "react-aria-components";
import { ListBoxItem } from "react-aria-components";
import { tv } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

type ListBoxItemProps = {
  className?: string;
} & AriaListBoxItemProps;

export function ListBoxItem2({ className, ...props }: ListBoxItemProps) {
  const { listBoxItem } = listBoxItemStyles();

  return <ListBoxItem className={cn(listBoxItem(), className)} {...props} />;
}

export const listBoxItemStyles = tv({
  slots: {
    listBoxItem: cn(
      "atom-keyboard-focus",
      "tw:flex tw:items-center tw:justify-between",
      "tw:text-md",
      "tw:px-2.5 tw:py-2",
      "tw:cursor-pointer tw:text-text-primary!",
      "tw:outline-none",
      "tw:transition-colors tw:duration-150",
      "tw:overflow-hidden tw:text-ellipsis tw:whitespace-nowrap",
      "tw:hover:bg-fill-bright-purple-quinary",
      "tw:data-focused:bg-fill-bright-purple-quinary",
      "tw:data-focus-visible:bg-fill-bright-purple-quinary",
      "tw:selected:bg-fill-bright-purple-quaternary",
      "tw:disabled:cursor-not-allowed tw:disabled:text-text-quaternary!",
    ),
  },
});
